import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { BusinessItemsQueryParams } from '../schemas/business-item'

/**
 * Query keys for business items
 */
export const business = createQueryKeys('business', {
  list: (params?: BusinessItemsQueryParams) => [{ params }],
  detail: (businessId: number) => [{ businessId }],
})
